"use strict";
import Application      from "./Application";
import PreloaderScene   from "./scenes/PreloaderScene";
import Common           from "./Common";
import isMobile         from "ismobilejs";
import MultiStyleText   from "./pixi-multistyle-text";

export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {PreloaderScene}
         * @private
         */
        this._preloader = null;
    }

    init(language) {

        Common.blankTexture = PIXI.Texture.WHITE;

        Common.assets = new P3.AssetManager();
        Common.audio = P3.Button.audio = new P3.AudioManager();
        Common.language = language;

        Common.assets.texture.bind(Common.assets);

        //--for legacy--//
        P3.Device = {};
        P3.Device.isMobile = isMobile.any;

        //wrapped to make compatible with p3lib v5
        Common.assets.getTexture = (name)=> {
            return Common.assets.texture(name);
        };
        Common.assets.getJSON = (name)=> {
            return Common.assets.json(name);
        };
        Common.assets.hasTexture = (name)=> {
            let bool = true;
            try {
                PIXI.Texture.fromFrame(name + ".png");
            } catch (err) {
                bool = false;
            }
            return (bool);
        };

        //Common.loadMute();
        //Common.loadGame();

        const isPortrait = false;

        const params = {};
        params.holderId = "game";
        params.width = this._width;
        params.height = this._height;
        params.portrait = isPortrait;
        params.aspectRatioFillHeight = !isPortrait;
        params.rotateImageUrl = "./assets/images/localisation/rotate/rotate_screen_" + language + ".jpg";
        params.rotateImageColor = "#000000";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;

        TweenMax.defaultOverwrite = "none";
        TweenMax.ticker.fps(60);

        const view = new P3.View(params);
        view.signals.ready.addOnce(function (canvas) {

            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1.0;

            Common.stage = new PIXI.Container();

            // hotfix
            canvas.screencanvas = true;

            // const input = new Input();
            // input.init(stage, canvas);
            //  Common.input = input;

            //on clicking the document focus on canvas, fix for buttons not working on mobile
            document.onclick = () => {
                canvas.focus();
            };

            const renderer = PIXI.autoDetectRenderer(this._width, this._height, options);
            renderer.backgroundColor = 0x000000;
            Common.renderer = renderer;
            Common.isWebGL = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new P3.SceneManager(renderer);
            scene.updateAll = true;
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            PIXI.ticker.shared.add(function (deltaTime) {

                window.P3.deltaTime = window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;
                P3.Timestep.deltaTime = window.deltaTime;
                scene.update();
                renderer.render(Common.stage);
            }, this);

            window.delay = function (callback, delay, scope) {
                TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.translate = function (str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        Common.view = view;
    }

    loadPreloader() {
        const files = [
            //sprite sheets
            {name: "ui_default_0_1x", url: "images/" + "ui_default_0_1x" + ".json"},
            {name: "ui_default_1_1x", url: "images/" + "ui_default_1_1x" + ".json"},
            {name: "preloader", url: "images/" + "preloader_1x" + ".json"},
            {name: "aeromaticslight_50", url: "fonts/" + "aeromaticslight_50" + ".xml"} //preloader font
        ];
        const sounds = [];
        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function () {
                this.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();
            Common.audio.addSounds(sounds, [".mp3", ".ogg"], "");
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {

        let files = [
            // json.
            {name: "languages", url: "data/" + "languages" + ".json"},
            {name: "config", url: "data/" + "config" + ".json"},
            {name: "draw_it", url: "data/" + "draw_it" + ".json"},
            // texture sheets.
            {name: "ui_default_0_1x", url: "images/" + "ui_default_0_1x" + ".json"},
            {name: "ui_default_1_1x", url: "images/" + "ui_default_1_1x" + ".json"},
            // raw images.
            {name: "game_title", url: "images/localisation/title/" + "title_" + Common.language + ".png"},

            {name: "colour_image_1", url: "images/outlines/colour_it/" + "image_1" + ".png"},
            {name: "colour_image_2", url: "images/outlines/colour_it/" + "image_2" + ".png"},
            {name: "colour_image_3", url: "images/outlines/colour_it/" + "image_3" + ".png"},
            {name: "colour_image_4", url: "images/outlines/colour_it/" + "image_4" + ".png"},
            {name: "colour_image_5", url: "images/outlines/colour_it/" + "image_5" + ".png"},
            {name: "colour_image_6", url: "images/outlines/colour_it/" + "image_6" + ".png"},
            {name: "colour_image_7", url: "images/outlines/colour_it/" + "image_7" + ".png"},
            {name: "colour_image_8", url: "images/outlines/colour_it/" + "image_8" + ".png"},
            {name: "colour_image_9", url: "images/outlines/colour_it/" + "image_9" + ".png"},
            {name: "colour_image_10", url: "images/outlines/colour_it/" + "image_10" + ".png"},

            {name: "draw_image_1", url: "images/outlines/draw_it/" + "image_1" + ".png"},
            {name: "draw_image_2", url: "images/outlines/draw_it/" + "image_2" + ".png"},
            {name: "draw_image_3", url: "images/outlines/draw_it/" + "image_3" + ".png"},
            {name: "draw_image_4", url: "images/outlines/draw_it/" + "image_4" + ".png"},
            {name: "draw_image_5", url: "images/outlines/draw_it/" + "image_5" + ".png"},
            {name: "draw_image_6", url: "images/outlines/draw_it/" + "image_6" + ".png"},
            {name: "draw_image_7", url: "images/outlines/draw_it/" + "image_7" + ".png"},
            {name: "draw_image_8", url: "images/outlines/draw_it/" + "image_8" + ".png"},
            {name: "draw_image_9", url: "images/outlines/draw_it/" + "image_9" + ".png"},
            {name: "draw_image_10", url: "images/outlines/draw_it/" + "image_10" + ".png"},

            // bgs.
            {name: "splash_bg", url: "images/bg/" + "splash_bg" + ".jpg"},
            {name: "bg", url: "images/bg/" + "bg_1x" + ".jpg"},
            // fonts.

            // particles.
            {name: "eraser_ps", url: "particles/" + "particle_emitter_eraser_loop_00" + ".json"},
            {name: "ink_ps", url: "particles/" + "particle_emitter_ink_loop_00" + ".json"},
            {name: "ink_splatter_ps", url: "particles/" + "particle_emitter_inksplatter_loop_01" + ".json"},
            {name: "brush_ps", url: "particles/" + "particle_emitter_paintbrush_loop_00" + ".json"},
            {name: "pencil_ps", url: "particles/" + "particle_emitter_pencil_loop_00" + ".json"},
            {name: "spray_ps", url: "particles/" + "particle_emitter_spray_loop_00" + ".json"},
            {name: "stamp_ps", url: "particles/" + "particle_emitter_stamo_burst_00" + ".json"},
            {name: "fill_ps", url: "particles/" + "particle_paintfill_burst_00" + ".json"},

            //--spine--//
            {name: "tutorial_hand", url: "images/" + "tutorial_hand" + ".json"}
        ];
        var music = [
            "music_mainmenu_loop_00",
            "music_ready_loop_012"
        ];
        var genericSfx = [
            "sfx_ambient_desert_loop_00",
            "sfx_drawer_hide_00",
            "sfx_drawer_reveal_00",
            "sfx_generic_colour_type_change_00",
            "sfx_tool_eraser_loop_03",
            "sfx_tool_eraser_select_00",
            "sfx_tool_inkpot_select_00",
            "sfx_tool_inkpot_use_splat_00",
            "sfx_tool_magictape_select_00",
            "sfx_tool_magictape_use_end_only_00",
            "sfx_tool_magictape_use_loop_00",
            "sfx_tool_paintbrush_dry_use_loop_00",
            "sfx_tool_paintbrush_select_00",
            "sfx_tool_paintbrush_wet_use_loop_00",
            "sfx_tool_paintpot_fill_select_01",
            "sfx_tool_paintpot_fill_use_02",
            "sfx_tool_pencil_select_00",
            "sfx_tool_pencil_use_loop_00",
            "sfx_tool_spraycan_select_00",
            "sfx_tool_spraycan_use_loop_00",
            "sfx_tool_stamp_use_00",
            "sfx_tool_stamps_select_00",
            "sfx_tool_sticker_end_only",
            "sfx_tool_sticker_place_00",
            "sfx_tool_sticker_use_00",
            "sfx_tool_stickers_select_00",
            "sfx_tool_trashcan_confirm_00",
            "sfx_tool_trashcan_select_00",
            "sfx_tool_undo_step_back_00",
            "sfx_ui_folder_save_00",
            "sfx_ui_newpage_00",
            "sfx_palette_select_00",
            "sfx_palette_close_00",
            "sfx_ui_carousel_swipe_00",
            "sfx_ui_click_00",
            "sfx_ui_rollover_00",
            //  "vo_happo_ok_00",
            //   "vo_happo_ooh_00",
            //   "vo_happo_ready_00",
            "sfx_btn_play_start_doorbell_00"
        ];
        if (files.length) {
            this._preloader = new PreloaderScene();
            Common.scene.add(this._preloader);

            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.progress.add(this.onLoadingProgress, this);
            Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            Common.assets.load();

            Common.audio.addSounds(music, [".m4a", ".ogg", ".mp3"], "assets/audio/music/");
            Common.audio.addSounds(genericSfx, [".m4a", ".ogg", ".mp3"], "assets/audio/sfx/");
        } else {
            this.startGame();
        }
    }

    createConfig() {
        const assets = Common.assets;

        const config = {};
        Common.config = config;
    }

    startGame() {

        delay(function () {
            if (!isMobile.any) Application.init();
        }, 1.0, this);

    }

    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();
        Common.finishedLoading = true;
        this._preloader.loaded = 1;

        this.startGame(1);
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(P3.View.width, P3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}

window.Main = Main;

/**
 *
 * @param copy
 * @param fontName
 * @param size
 * @param holder
 * @param colour
 * @returns {PIXI.Text}
 */
function simpleText(copy, fontName, size, holder, colour) {
    const col = colour | 0x000000;
    const textView = new PIXI.Text(copy, {fontFamily: fontName, fontSize: size, fill: col});
    textView.anchor.x = 0.5;
    if (holder) holder.addChild(textView);
    return textView;
}
P3.simpleText = simpleText;

/**
 * Creates and returns a new UI button
 * @param point {PIXI.Point}
 * @param type
 * @param callback
 * @param scope
 * @param params
 * @returns {Button}
 */
/*
 function createButton(point, type, callback, scope, params = {holder: null, text: null, icon: null}) {

 const states = new P3.ButtonStates();

 if (!type || type === "blank") {

 states.normal = PIXI.Texture.EMPTY;
 states.down = PIXI.Texture.EMPTY;

 } else if (typeof type === "string") {

 if (Common.assets.hasTexture("btn_" + type + "_up")) {
 states.normal = Common.assets.texture("btn_" + type + "_up");
 } else if (Common.assets.hasTexture("buttons/ui_" + "btn_" + type + "_up")) {
 states.normal = Common.assets.texture("buttons/ui_" + "btn_" + type + "_up");
 }

 if (Common.assets.hasTexture("btn_" + type + "_down")) {
 states.down = Common.assets.texture("btn_" + type + "_down");
 } else if (Common.assets.texture("buttons/ui_" + "btn_" + type + "_down")) {
 states.down = Common.assets.texture("buttons/ui_" + "btn_" + type + "_down");
 }

 if (Common.assets.hasTexture("btn_" + type + "_over")) {
 states.over = Common.assets.texture("btn_" + type + "_over");
 }

 } else {

 states.normal = type;

 }

 const button = new Button(states);
 button.x = point.x;
 button.y = point.y;
 button.anchor = new PIXI.Point(0.5, 0.5);
 button.animate = true;

 button.signals.click.add(callback, scope);

 //  buttons/ui_icon_close

 if (params) {
 if (params.holder) {
 params.holder.addChild(button);
 }
 if (params.icon) {
 let sp;
 if (Common.assets.hasTexture(params.icon)) {
 sp = P3.createSprite(params.icon);
 } else {
 sp = P3.createSprite("buttons/ui_" + params.icon);
 }
 sp.anchor.set(0.5);
 button.addChild(sp);
 button.icon = sp;
 }
 if (params.text) {
 let txtView = P3.simpleText(params.text, "consolas", 45, button, 0xffffff);//new PIXI.extras.BitmapText(text, {font: "45px Calibri"});
 txtView.anchor = {x: 0.5, y: 0.5};
 button.txtView = txtView;
 }
 }

 return button;
 }
 P3.createButton = createButton;
 */

/**
 * @param copy {string}
 * @param config {object}
 * @param override {string} - overrides default language font type
 * @param jsonName
 * @returns {PIXI.Text|PIXI.BitmapText}
 */
function createText(copy, config, override, jsonName) {
    var textView, conf;
    var str = jsonName || "languages";
    if (Common.language === "ar") {
        conf = {
            font: config.size + " Noto Kufi Arabic",
            fill: config.fill,
            align: "center",
            //  letterSpacing: 5,
            padding: config.padding || 0
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 4 || config.strokeThickness;
        }
        Object.assign(conf, config);
        textView = new PIXI.Text(Common.assets.getJSON(str)[copy][Common.language], conf);
    } else {
        conf = {
            font: config.size + " Duality",
            fill: config.fill,
            align: "center",
            letterSpacing: 4,
            padding: config.padding || 0,
            lineJoin: "round"
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 8;
        }
        Object.assign(conf, config);
        textView = new PIXI.Text(Common.assets.getJSON(str)[copy][Common.language], conf);
    }

    return textView;
}
P3.createText = createText;

/**
 * @param copy {string}
 * @param config
 */
function createMultiText(copy, config) {
    var textView, conf;
    var str = "languages";
    if (Common.language === "ar") {
        conf = {
            font: config.size + " Noto Kufi Arabic",
            fill: config.fill,
            align: "center",
            padding: config.padding || 0
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 4 || config.strokeThickness;
        }
        textView = new PIXI.Text(Common.assets.getJSON(str)[copy][Common.language], conf);
    } else {
        conf = {
            font: config.size + " Duality",
            fill: 0xffffff,
            align: "center",
            letterSpacing: 4,
            padding: config.padding || 0,
            lineJoin: "round"
        };
        if (config.wordWrapWidth) {
            conf.wordWrap = true;
            conf.wordWrapWidth = config.wordWrapWidth;
        }
        if (config.stroke) {
            conf.stroke = config.stroke;
            conf.strokeThickness = 8;
        }

        //LOL...
        let confCopy = Object.assign({}, conf);
        delete confCopy.fill;
        let realConfig = {//deliberately made larger than needs to be, trying to ovoid overflow
            "default": conf,
            "s0": Object.assign({fill: "#fff200"}, confCopy),//
            "s1": Object.assign({fill: "#00bff3"}, confCopy),//
            "s2": Object.assign({fill: "#00a650"}, confCopy),//
            "s3": Object.assign({fill: "#00bff3"}, confCopy),//
            "s4": Object.assign({fill: "#ff4b96"}, confCopy),//
            "s5": Object.assign({fill: "#ff2600"}, confCopy),//red
            "s6": Object.assign({fill: "#f26522"}, confCopy),//orange
            "s7": Object.assign({fill: "#fff200"}, confCopy),//yellow
            "s8": Object.assign({fill: "#00a650"}, confCopy),//green
            "s9": Object.assign({fill: "#fff200"}, confCopy),
            "s10": Object.assign({fill: "#00bff3"}, confCopy),
            "s11": Object.assign({fill: "#00a650"}, confCopy),
            "s12": Object.assign({fill: "#00bff3"}, confCopy),
            "s13": Object.assign({fill: "#ff4b96"}, confCopy),
            "s14": Object.assign({fill: "#f26522"}, confCopy),
            "s15": Object.assign({fill: "#fff200"}, confCopy),
            "s16": Object.assign({fill: "#00a650"}, confCopy),
            "s17": Object.assign({fill: "#ff2600"}, confCopy),
            "s18": Object.assign({fill: "#00a650"}, confCopy),
            "s19": Object.assign({fill: "#00a650"}, confCopy),
            "s20": Object.assign({fill: "#00a650"}, confCopy),
            "s21": Object.assign({fill: "#00a650"}, confCopy),
            "s22": Object.assign({fill: "#00a650"}, confCopy),
            "s23": Object.assign({fill: "#00a650"}, confCopy)
        };

        let realCopy = Common.assets.getJSON(str)[copy][Common.language];
        let copyArr = realCopy.split("");
        let finalCopy = "";
        for (let i = 0; i < copyArr.length; i++) {
            finalCopy += "<s" + i + ">";
            finalCopy += copyArr[i];
            finalCopy += "</s" + i + ">";
        }

        //--create the text--//
        textView = new MultiStyleText(finalCopy, realConfig);
    }

    return textView;
}
P3.createMultiText = createMultiText;

function createButton(icon, type) {
    type = type || 'primary_small';
    const buttonStates = new P3.ButtonStates(
        Common.assets.getTexture('btn_' + type + '_off'),
        Common.assets.getTexture('btn_' + type + '_over'),
        Common.assets.getTexture('btn_' + type + '_down'),
        Common.assets.getTexture("icon_" + icon + '_off')
    );

    buttonStates.iconOver = Common.assets.getTexture("icon_" + icon + '_over');
    buttonStates.iconDown = Common.assets.getTexture("icon_" + icon + '_down');

    let button;
    if (icon === 'sound') {
        buttonStates.iconAlt = Common.assets.getTexture('icon_' + "mute" + '_off');
        buttonStates.iconOverAlt = Common.assets.getTexture('icon_' + "mute" + '_over');
        buttonStates.iconDownAlt = Common.assets.getTexture('icon_' + "mute" + '_down');
        button = new P3.MuteButton(buttonStates);
    }
    else {
        button = new P3.Button(buttonStates);
    }
    return button;
}

window.createButton = createButton;

function Timestep() {

}
Timestep.deltaTime = 0;
P3.Timestep = Timestep;
